import { render, staticRenderFns } from "./ListarPedidos.vue?vue&type=template&id=3538526c&scoped=true&"
import script from "./ListarPedidos.vue?vue&type=script&lang=js&"
export * from "./ListarPedidos.vue?vue&type=script&lang=js&"
import style0 from "./ListarPedidos.vue?vue&type=style&index=0&id=3538526c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538526c",
  null
  
)

export default component.exports